<script>
  import ValidatorMixin from "../mixins/validator";

  export default {
    props: {
      outgoingNumbers: Array,
      storeUrl: String,
    },

    data() {
      return {
        errors: {},
        isBusy: false,
      };
    },

    methods: {
      /**
       * @return {Object}
       */
      getForm() {
        return _.assign({}, this.form);
      },

      /**
       * @return {undefined}
       */
      save() {
        this.isBusy = true;
        axios.post(this.storeUrl, this.getForm())
          .then(this.onSuccess)
          .catch(this.onError)
          .finally(() => this.isBusy = false);
      },

      /**
       * @param {Object} data
       * @param {String|undefined} message
       */
      onSuccess({data: {data, message}}) {
        this.$emit('created', {
          model: data,
          message: message || 'The message sent',
        });
      },

      /**
       * @param {Number} status
       * @param {Array|undefined} errors
       * @param {String|undefined} message
       */
      onError({response: {status, data: {errors, message}}}) {
        if (status === 422 && errors) {
          this.errors = errors;
          this.$refs.form.validate(() => null);

        }
        message && this.$message.error(message);
      },

      /**
       * @param {Object} outgoingNumber
       * @return {String}
       */
      formatOutgoingNumber({title, phone_number}) {
        return title
          ? `${title}(${phone_number})`
          : `${phone_number}`;
      }
    },

    mixins: [
      ValidatorMixin
    ],
  }
</script>
